/**
 * The single post-purchase landing destination for Career OS Bundle buyers.
 * The activation flag lets the hub show a one-time first-run handoff without
 * creating a separate product surface.
 */
export function getCareerBundleActivationPath(locale: string): string {
  return `/${locale}/dashboard/career-os?activated=bundle`;
}

export function getCareerOsPath(locale: string): string {
  return `/${locale}/dashboard/career-os`;
}
